/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DashboardServiceabilityAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to manage the serviceability view.
 */
define([], () => {
	class DashboardServiceabilityAPI{
		/**
		 * @function DashboardServiceabilityAPI#openPanel
		 * @description Open the s12y view
		 * @param {object} contentInfo All information needed to display
		 * @return {Promise<boolean>} promise resolved with a boolean that indicates that the state of pane (open or not)
		 */
		openPanel(){}

		/**
		 * @function DashboardServiceabilityAPI#closePanel
		 * @description hide the s12y view
		 * @return {Promise<boolean>} promise resolved whe the panel is completely hidden
		 */
		closePanel(){}

		/**
		 * @function DashboardServiceabilityAPI#getPanelState
		 * @description return a promise that will be resolved with panel state
		 * @return {Promise<Object>} panelState - {isOpen:true|false}
		 * 
		 */
		getPanelState(){}

		/**
		 * @function DashboardServiceabilityAPI#showInfo
		 * @description show info on all contents
		 */
		showInfo(){}

		/**
		 * @function DashboardServiceabilityAPI#hideInfo
		 * @description hide info on all contents
		 */
		hideInfo(){}

		/**
		 * @function DashboardServiceabilityAPI#isInfoVisible
		 * @description return true if info is visiable on all contents, false otherwise
		 * @returns {Boolean}
		 */
		isInfoVisible(){}

	}

	return DashboardServiceabilityAPI;
});
